export const ASSETS_APP_KEY = 'ASSETS';
export const TENANTLESS_ORG_ID = 'tenantless';

// ARIA tabs id prefixes for the App Switcher for Units rail (tabs) and content column (tabpanel).
export const SWITCHER_TAB_BUTTON_PREFIX = 'switcher-tab';
export const SWITCHER_TAB_PANEL_PREFIX = 'switcher-tabpanel';

// App Switcher for Units resizable rail consts. Widths are unitless pixel
// numbers so the resize state machine can do arithmetic on them; consumers
// append `px` when applying to the DOM.
export const ORG_UNIT_RAIL_COLLAPSED_WIDTH = 72;
export const ORG_UNIT_RAIL_DEFAULT_WIDTH = 268;
export const ORG_UNIT_RAIL_MAX_WIDTH = 400;
// Below this drag width the rail snaps closed to the collapsed width.
export const ORG_UNIT_RAIL_MIN_EXPAND_WIDTH = 136;
// Fixed width of the panel's right-hand content column (the app list).
export const ORG_UNIT_CONTENT_WIDTH = 336;
// Delay before the resize handle's tooltip appears, in ms.
export const ORG_UNIT_RESIZE_TOOLTIP_DELAY_MS = 1000;

// localStorage key persisting the user's chosen rail width. Reuses the key from
// the removed org-selector resize implementation so no new key needs allowlisting.
// The resize control clamps any restored value into the [collapsed, max] range.
export const ORG_UNIT_RAIL_WIDTH_LS_KEY = 'AS_ORG_SELECTOR_WIDTH';

// Reads the persisted rail width from browser storage, clamped into the
// [collapsed, max] range, falling back to the default when nothing is stored or
// the value is invalid. Shared so the parent (initial render) and the resize
// control read one source of truth — the persisted width is applied on the very
// first render, so it survives refreshes and any rail remount.
export const getPersistedRailWidth = (widthFromStorage: string | null): number => {
	const parsed = widthFromStorage ? parseInt(widthFromStorage, 10) : NaN;
	return Number.isFinite(parsed)
		? Math.min(Math.max(parsed, ORG_UNIT_RAIL_COLLAPSED_WIDTH), ORG_UNIT_RAIL_MAX_WIDTH)
		: ORG_UNIT_RAIL_DEFAULT_WIDTH;
};
